var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{attrs:{"id":"results"}},[_c('div',{staticClass:"container -large"},[(_vm.menu === _vm.menuConstant.MENU_1)?_c('ResultCustom'):_vm._e(),(_vm.menu === _vm.menuConstant.MENU_2)?_c('ResultRecommend'):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }